module.exports = __webpack_public_path__ + "img/reference29.a96eece2.jpg";